{
  "login": {
    "title": "ログイン",
    "intro": "店舗スタッフ用の管理画面です。",
    "email": "メールアドレス",
    "password": "パスワード",
    "show_password": "パスワードを表示",
    "hide_password": "パスワードを隠す",
    "caps_lock": "Caps Lock がオンになっています",
    "submit": "ログイン",
    "submitting": "ログイン中…",
    "forgot": "パスワードを忘れた場合",
    "dev_bypass_hint": "開発モード：任意のメールアドレスとパスワードでログインできます。"
  },
  "totp": {
    "title": "6桁のコードを入力",
    "intro": "認証アプリ（Google Authenticator・1Password など）を開き、このお店のコードを入力してください。",
    "code": "6桁のコード",
    "submit": "次へ",
    "use_recovery": "バックアップコードを使う",
    "use_app": "アプリのコードを使う",
    "recovery_code": "バックアップコード",
    "recovery_intro": "アプリを設定したときに印刷・保存したバックアップコードを1つ入力してください。各コードは1回だけ使えます。",
    "back": "ログインに戻る"
  },
  "setup": {
    "title": "コードアプリでアカウントを守りましょう",
    "intro": "オーナーと店長はログイン時に2段階目の確認が必要です。約2分で終わります。",
    "step1_title": "1. 認証アプリを入れる",
    "step1_body": "スマートフォンに Google Authenticator、Microsoft Authenticator、1Password のどれか（無料）を入れてください。",
    "step2_title": "2. アプリでこの画像を読み取る",
    "step2_body": "アプリで「+」を押し、「QRコードをスキャン」を選びます。",
    "qr_alt": "認証アプリにこのお店を追加するためのQRコード",
    "manual": "読み取れない場合は、このキーをアプリに入力してください：",
    "copy_secret": "キーをコピー",
    "copied": "コピーしました",
    "step3_title": "3. アプリに表示された6桁のコードを入力",
    "code": "6桁のコード",
    "submit": "コードを確認",
    "loading": "QRコードを準備中…",
    "codes_title": "バックアップコードを保存してください",
    "codes_intro": "スマートフォンをなくしたとき、これらのコードで1回ずつログインできます。ダウンロードして安全な場所（同じスマートフォン以外）に保管してください。",
    "download": "バックアップコードをダウンロード",
    "print": "印刷",
    "downloaded": "ダウンロードしました — 安全な場所に保管してください。",
    "must_download": "先にバックアップコードをダウンロードしてください — もう一度は表示されません。",
    "confirm_saved": "バックアップコードを保存しました",
    "continue": "管理画面へ進む",
    "file_heading": "ショップ管理のバックアップコード — 各コードは1回だけ使えます",
    "done": "2段階ログインがオンになりました"
  },
  "change": {
    "title": "新しいパスワードを決める",
    "intro": "仮パスワードでの初めてのログインです。続けるには自分のパスワードを決めてください。",
    "current": "仮パスワード",
    "current_profile": "現在のパスワード",
    "new": "新しいパスワード",
    "confirm": "新しいパスワード（確認）",
    "submit": "新しいパスワードを保存",
    "mismatch": "2つの新しいパスワードが一致しません",
    "saved": "パスワードを変更しました。ほかの端末はログアウトされました。"
  },
  "strength": {
    "label": "パスワードの強さ",
    "rule": "12文字以上。短い文にすると覚えやすいです。",
    "too_short": "短すぎます — あと {{count}} 文字",
    "weak": "弱い",
    "fair": "ふつう",
    "strong": "強い"
  },
  "forgot": {
    "title": "パスワードの再設定",
    "intro": "スタッフアカウントのメールアドレスを入力してください。新しいパスワードを決めるリンクを送ります。",
    "email": "メールアドレス",
    "submit": "リンクを送る",
    "sent_title": "メールを確認してください",
    "sent_body": "このメールアドレスがスタッフアカウントのものなら、リンクを送りました。30分間有効です。",
    "back": "ログインに戻る"
  },
  "reset": {
    "title": "新しいパスワードを決める",
    "missing_token": "このリンクは不完全です。メールのリンクをもう一度開くか、新しいリンクを依頼してください。",
    "submit": "新しいパスワードを保存",
    "done_title": "パスワードを保存しました",
    "done_body": "新しいパスワードでログインできます。",
    "sign_in": "ログイン",
    "ask_again": "新しいリンクを送る"
  },
  "expired": {
    "title": "時間切れです — もう一度ログインしてください",
    "body": "安全のためログアウトしました。このページの入力内容は下書きとして残り、ログイン後に戻ります。",
    "sign_in": "もう一度ログイン"
  },
  "profile": {
    "title": "マイアカウント",
    "intro": "ログイン・言語・端末の設定です。",
    "details": "自分の情報",
    "name": "名前",
    "role": "役割",
    "language": "管理画面の言語",
    "language_hint": "自分だけの設定です。ほかのスタッフはそれぞれの言語のままです。この端末に保存されます。",
    "language_saved": "言語を変更しました",
    "password_title": "パスワード",
    "password_change": "パスワードを変更",
    "password_saved": "パスワードを変更しました。ほかの端末はログアウトされました。",
    "two_step": "2段階ログイン（コードアプリ）",
    "two_step_on": "オン",
    "two_step_off": "オフ",
    "two_step_turn_on": "オンにする",
    "sessions_title": "ログイン中の端末",
    "sessions_intro": "あなたのアカウントが開いているブラウザやスマートフォンです。",
    "this_device": "この端末",
    "last_used": "最終利用 {{time}}",
    "signed_in_at": "ログイン {{time}}",
    "unknown_device": "不明なブラウザ",
    "sign_out_others": "ほかのすべての端末からログアウト",
    "sign_out_others_title": "ほかのすべての端末からログアウトしますか？",
    "sign_out_others_body": "ほかのブラウザやスマートフォンはすべて再ログインが必要になります。この端末はログインしたままです。",
    "signed_out_others_other": "ほかの {{count}} 台からログアウトしました",
    "no_other_sessions": "ほかの端末はありません"
  },
  "errors": {
    "invalid": "メールアドレスまたはパスワードが正しくありません。",
    "not_available": "ログインはまだ接続されていません。スタッフアカウントは認証サービスと一緒に提供されます。",
    "locked": "間違いが続いたため、アカウントを一時停止しています。",
    "locked_retry": "間違いが続きました — {{minutes}} 分後にもう一度試すか、オーナーに相談してください。",
    "rate_limited": "短時間に試しすぎです — 少し待ってください。",
    "rate_limited_retry": "試しすぎです — {{minutes}} 分後にもう一度お試しください。",
    "code_invalid": "コードが正しくありません。アプリの最新のコードを入力してください。",
    "challenge_expired": "時間がかかりすぎました。メールアドレスとパスワードからやり直してください。",
    "weak_password": "もっと長いパスワードにしてください（12文字以上、よくあるものは不可）。",
    "network": "お店のシステムに接続できません — インターネット接続を確認してください。",
    "unknown": "ログインできませんでした。もう一度お試しください。"
  },
  "invite": {
    "title": "パスワードを設定",
    "intro": "{{name}} さん、ようこそ。ログインには {{email}} を使います。",
    "two_step": "パスワードの後に、スマートフォンの認証アプリで2段階認証を設定します。スマートフォンをご用意ください。",
    "valid_until": "このリンクは1回だけ、{{until}}（日本時間）まで使えます。",
    "submit": "保存して次へ",
    "missing": "リンクが不完全です。招待メールのリンクをもう一度開いてください。",
    "used_or_expired": "この招待リンクは使用済みか、期限が切れています。オーナーに招待の再送を依頼してください。",
    "sign_in_now": "パスワードを保存しました。メールアドレスと新しいパスワードでログインしてください。",
    "to_login": "ログインへ"
  }
}
